var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100"},[_c('LinkingState',{attrs:{"is-logged-in":_vm.isLoggedIn}}),(_vm.isLoggedIn)?_c('router-view'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }